/*eslint-disable*/
import React, { useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import makeStyles from "@mui/styles/makeStyles";

import styles from "assets/jss/default/components/footerStyle.js";
import moment from "moment";
import { Tooltip } from "@mui/material";
import getFrontEndVersion from "components/utils";
import { siteSettings } from "core/siteSettings";
const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const [currentYear] = useState(() => moment().year());
  const { fluid, white } = props;
  const container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white
  });
  return (
    <footer className={classes.footer}>
      <Tooltip
        title={`${siteSettings.frontEndVersion} ${getFrontEndVersion()}`}
      >
        <div className={container}>
          <p className={classes.center}>
            &copy; {currentYear} Insight Analytics Solutions Ltd. trading as
            ONYX Insight
          </p>
        </div>
      </Tooltip>
    </footer>
  );
}

Footer.propTypes = {
  fluid: PropTypes.bool,
  white: PropTypes.bool,
  rtlActive: PropTypes.bool
};
